import { render, staticRenderFns } from "./bookmark-button.vue?vue&type=template&id=5a5f8b4c"
import script from "./bookmark-button.vue?vue&type=script&lang=js"
export * from "./bookmark-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports